import React from 'react';
import styles from './Header.module.scss';

interface HeaderItemProps {
  text: string;
  icon: string;
  className?: string;
  onClick?: () => void;
}

const HeaderItem: React.FC<HeaderItemProps> = ({ text, icon, className, onClick }) => {
  return (
    <button className={`${styles.headerItem} ${className}`} aria-label={text} onClick={onClick}>
      {/* alt ריק ולא חסר: האייקון מלווה את הטקסט שלצידו ואינו מוסיף מידע.
          בלי התכונה בכלל קורא מסך מקריא את שם קובץ התמונה (WCAG 1.1.1). */}
      <img src={icon} alt="" />
      <span className="body-md-regular">{text}</span>
    </button>
  );
};

export default HeaderItem;
